import CTAStepExplanations from 'components/CTAStepsExplanation/CTAStepExplanations';

/**
 * This component is a placeholder for the StepExplanations component to be able to link it via Contentful.
 */
export function StepExplanationsLink() {
  return <CTAStepExplanations headline="So einfach geht's" />;
}
